import React from 'react';
import { Alert } from 'reactstrap';
import { TypedMemo } from '../../types';
import { ErrorAlertRendererProps } from './props';
import { withBrandWord } from '../../../music24/components/primitives/BrandWord';

const ErrorAlertRendererComponent: React.FC<ErrorAlertRendererProps> = ({ message }) => {
  return <Alert color="danger text-break">{withBrandWord(message)}</Alert>;
};

export const ErrorAlertRenderer = TypedMemo(ErrorAlertRendererComponent);
